import { render, staticRenderFns } from "./logoutComponent.vue?vue&type=template&id=1447d06b&"
import script from "./logoutComponent.vue?vue&type=script&lang=js&"
export * from "./logoutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports